import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import {
  EntityActionNames,
  IEntityAction,
} from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ILabelValueAction } from '~src/spacesPlatform/models/actionNames';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { Messages } from '../../../codegen/Localize';
import { setLabelValueAction } from '../../actions/labels/SetLabelValueAction';
import { ILabelValueInfo } from '../../models/ILabelValueInfo';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

/**
 * Unified entity action for editing label values (release 262).
 * Replaces SetCertificationOrTriggerWarning and SetSensitiveOrWarningLabelValue.
 * Shows "Edit" menu item for all label types when the user is an admin.
 * The dialog behavior (which fields are editable) is determined by LabelTypeConfig
 * in catalog-ui based on the label's category and value.
 */
export const SetLabelValueEntityAction: IEntityAction<
  ILabelValueInfo,
  ILabelValueAction
> = {
  name: EntityActionNames.SetLabelValue,
  translateName: Messages.edit,
  isVisible: (items, state) =>
    selectCatalogingOnSiteEnabled(state) &&
    FeatureFlags.labelManagementEnabled &&
    currentUserIsAdmin(state),
  isClickable: (_, targetItems) => targetItems.length === 1,
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error(Messages.setLabelValueError());
    }
    return setLabelValueAction(items[0]);
  },
};
